import { render, staticRenderFns } from "./Climate.vue?vue&type=template&id=a4350588"
import script from "./Climate.vue?vue&type=script&lang=js"
export * from "./Climate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports